export default __webpack_public_path__ + "static/media/commerce.f86b0404.jpg";